import '../landing';
import '../legal';
import init_navigation from '../navigation';
import 'lazysizes';

document.addEventListener('turbolinks:load', () => {
  init_navigation();
});

